module.exports = __webpack_public_path__ + "static/media/sponcer_PERFECT.96033be9.svg";